module.exports = __webpack_public_path__ + "static/media/M.1a8da775.svg";